<script setup lang="ts">
definePageMeta({
  middleware: ['02-pharmacy-routing'],
  nonPharmacyRoute: 'express-botendienst',
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
